import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { I18nModule } from '@spartacus/core'
import { EbIndicatorModule } from '../../../../components/indicators/eb-indicator.module'
import { EbProductAvailabilityComponent } from './eb-product-availability.component'

@NgModule({
  declarations: [EbProductAvailabilityComponent],
  imports: [CommonModule, I18nModule, EbIndicatorModule],
  exports: [EbProductAvailabilityComponent]
})
export class EbProductAvailabilityModule {}
